enum TeamsOrGroups {
  Teams,
  Groups,
  AnalysisGroups,
}

export default TeamsOrGroups;
